<template>
  <div class="trChangeDetail linear-main3">
    <ld-header
      transparent
      white
    >
      改签详情
    </ld-header>

    <van-pull-refresh
      class="train-detail-content"
      v-model="isLoading"
      @refresh="getDetail"
    >
      <div class="pad16 white">
        <div class="font-lg font24 fontTitle">
          <span>{{ detail.changeStatusName }}</span> 
          <ld-email-popup
            v-if="id"
            :id="id"
            :djlx="11011"
            :order-no="detail.orderNo"
          />
        </div>
        <van-row class="font12">
          {{ $t('K121','申请时间') }}：{{ detail.applyDate }}
        </van-row>
        <van-row class="font12">
          {{ $t('I109','改签原因') }}：{{ detail.changeReasonVip }}
        </van-row>

        <van-notice-bar
          v-if="detail.isReject"
          class="clbz-bar"
          mode="link"
          :scrollable="false"
          @click="$dialog({title: $t('C452','拒单原因'), message: detail.errMsg})"
        >
          <span>{{ $t('C452','拒单原因') }}：{{ detail.errMsg }}</span>
        </van-notice-bar>
      </div>

      <div
        class="pad8" 
        v-if="detail.changeNo"
      >
        <van-row class="round-sm pad8 van-row bg-white">
          改签单编号：{{ detail.orderNo }}
          
          <router-link
            class="main-color fr"
            :to="`/tr/OrderDetail/${detail.orderId}`"
          >
            {{ $t('C338','查看原订单') }}
          </router-link>
        </van-row>

        <!-- 支付方式 -->
        <van-row
          v-if="detail.payStatus == 1"
          class="round-sm mt5 pad8 orange bg-lightYellow"
        >
          {{ detail.payMethodDesc }}
        </van-row>
        
        <!-- 原订单信息 -->
        <div class="round-sm mt5 bg-white">
          <van-row
            v-if="detail.takeTicketCode"
            class="font12 pad8 gray"
          >
            <van-tag type="warning">
              改
            </van-tag>
            取票号：{{ detail.takeTicketCode }}
          </van-row>
          <stop-station
            class="van-hairline--bottom"
            :detail="detail.newDetail"
            train-no-class="main-color"
          />
        </div>
        
        <!-- 改签后火车信息 -->
        <div class="round-sm mt5 bg-white">
          <van-row
            v-if="detail.takeTicketCode"
            class="font12 pad8 gray"
          >
            <van-tag type="primary">
              原
            </van-tag>
          </van-row>
          <stop-station
            class="van-hairline--bottom"
            :detail="detail.oldDetail"
          />
          <van-row class="font12 pad8 text-center">
            <router-link
              to="/tr/OrderService"
              class="main-color"
            >
              {{ $t('F010','退改签规则') }}
            </router-link>
          </van-row>
        </div>


        <!-- 乘车人列表 -->
        <van-cell-group class="mt5 round-sm">
          <psg-panel
            v-for="(passenger, i) in detail.psgList"
            :key="i"
            :passenger="passenger"
          />
        </van-cell-group>
        
        <!-- 退票详 -->
        <div />

        <!-- 改签进度 -->
        <!-- <van-cell class="mt5">
          <h3>改签进度：</h3>
        </van-cell>
        <van-steps
          class="ld-step"
          direction="vertical"
          :active="detail.changeStatus"
        >
          <van-step>
            <h3>申请已提交</h3>
            <p class="mt5">
              {{ detail.applyDate }}
            </p>
          </van-step>
          <van-step>
            <h3>送审</h3>
          </van-step>
          <van-step>
            <h3>已订座</h3>
          </van-step>
          <van-step>
            <h3>已支付</h3>
          </van-step>
          <van-step>
            <h3>完成</h3>
          </van-step>
        </van-steps> -->

        <!-- 审批规则 -->
        <approval
          class="mt5 round-sm"
          v-if="detail.showApprovalRule"
          :order-id="id"
          :vip-status="detail.vipStatus"
          :spgz-id="detail.appId"
          :isssbz="detail.isShowApproval!='1'"
        />
        <ld-uploader
          class="mt5 round-sm overflow"
          v-if="id"
          :order-id="id"
          :glywlx="'11011'"
          :cjlx="2"
          :orderStatus='detail.ChangeDetail'
        />
      </div>
    </van-pull-refresh>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        justify="space-between"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          offset="1"
          span="11"
        >
          <span class="font12 red">&yen;</span>
          <span class="font24 red">{{ detail.changeAmount }}</span>

          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          span="6"
          class="pad5"
        >
          <ld-button
            defaults
            size="md"
            v-if="detail.showRefundButton == 1"
            @click.stop="btnClick('refund')"
          >
            {{ $t('B035','退票') }}
          </ld-button>
          <ld-button
            defaults
            size="md"
            class="font12"
            v-if="detail.showCancelButton == 1"
            @click.stop="btnClick('cancel')"
          >
            {{ $t('B008','取消') }}
          </ld-button>
        </van-col>
        
        <van-col
          span="6"
          class="pad5"
        >
          <ld-button
            main
            size="md"
            class="font12"
            v-if="detail.showPayButton == 1"
            @click.stop="pay"
          >
            改签支付
          </ld-button>
          <ld-button
            v-if="detail.isShowCancelApproval == 1"
            defaults
            size="md"
            @click.native="btnClick('revertApproval')"
          >
            {{ $t('B065','撤回') }}
          </ld-button>
          <ld-button
            main
            size="md"
            v-if="detail.showSendCkButton == 1"
            @click.stop="btnClick('approval')"
          >
            {{ $t('B028','送审') }}
          </ld-button>
          <ld-button
            main
            size="md"
            class="font12"
            v-if="detail.showSendCkButton == 2"
            @click.stop="btnClick('approval')"
          >
            {{ $t('Submit','再送审') }}
          </ld-button>
          <ld-button
            main
            size="md"
            class="font12"
            v-if="detail.showConfirmButton == 1"
            @click.stop="btnClick('confirmChange')"
          >
            {{ $t('B050','确认改签') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
   
    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      :order-type="detail.orderType"
      :order-id="id"
    /> -->
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票改签详情
 * @desc 
 * @param {String} id 火车票改签订单id
 */

import { CellGroup, Cell, PullRefresh, Step, Steps, NoticeBar, Tag, Popup } from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
// import ldPay from 'Components/ldPay/index.vue'
import approval from 'Components/approval/approval'
import StopStation from '../trQuery/StopStation'
import PsgPanel from '../trOrder/PsgPanel'
import handle from './handle'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'
import ldEmailPopup from 'Components/LdEmailPopup'
import ldUploader from 'Components/ldUploader'

export default {
  provide: {
    orderType: $dict.ORDER_TYPE.tr.change
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [NoticeBar.name]: NoticeBar,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    StopStation, PsgPanel, ldButton, 
    ldTabbar, 
    // ldPay,
    approval,
    ldEmailPopup,
    ldUploader
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      detail: {},
      refundList: [],
      spjd: '',
      vipStatus: '',
    }
  },
  created() {
    this.getDetail()
    this.getRefundListByOrderId()
    this.getAlterProgress()
  },
  methods: {
    async getDetail() {
      this.isLoading = true
      
      const { data } = await TrainOrderInteractor.getChangeDetailById(this.id)
      
      this.isLoading = false
      this.detail = data
    },
    // 获取退票详
    async getRefundListByOrderId() {
      const { data } = await TrainOrderInteractor.getRefundListByOrderId(this.id)
      this.refundList = data
    },
    // 获取 改签进度
    async getAlterProgress() {
      const { data } = await TrainOrderInteractor.getChangeProgress(this.id)
      this.spjd = data.spjd
      this.vipStatus = data.vipStatus
    },
    async btnClick (handleType) {
      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    },
    pay() {
      // this.$refs.pay.toggle()
      this.$router.push({path:'/pay/payment',query:{orderType:this.detail.orderType,orderId:this.id}})
    }
  },
  computed: {
    priceList () {
      let rt = [
        { name: '合计', price: this.detail.changeAmount },
        { name: '新票价', price: this.detail.newTicketPrice },
        { name: '旧票价', price: this.detail.oldTicketPrice },
        { name: '改签差价', price: this.detail.priceDiff },
        { name: '改签手续费', price: this.detail.buyChangePoundage },
        { name: '服务费', price: this.detail.buyServiceCharge }
      ]
      return rt
    }
  }
}
</script>

<style lang="less">
@import "~Assets/styles/business.less";
.trChangeDetail {
  .fontTitle{
    display: flex;
    justify-content:space-between;
    align-items:center;
    .dowPdf{
      font-size: 16px;
    }
  }
  p, h3 {
    margin: 0;
  }
  

  .pad5 {
    padding: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .pad16{
    padding: 16px;
  }
  .mt5 {
    margin-top: 5px;
  }
  .train-detail-content {
    padding-bottom: 100px;
  }

  .round-sm {
    overflow: hidden;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }
}
</style>